import { StateService } from '@pulse/browser-shared';
import {
    Experiment,
    Infected,
    PulseStorage,
    StorageChangeKeyMatch,
    StorageChangeOrigin,
    TrackerConfigurations,
} from '@pulse/common';
import { Subject } from 'rxjs';

export class ExperimentsService {
    private infected: Infected[] = [];
    public newExperimentTrigger$ = new Subject<boolean>();
    constructor(
        private pulseStorage: PulseStorage,
        private config: TrackerConfigurations,
        private stateService: StateService,
    ) {
        this.infected = this.getInfectedFromStorage();
        this.stateService.setState({ infected: this.infected });
        this.pulseStorage
            .change(
                this.config.experimentStorageKey,
                StorageChangeKeyMatch.Full,
                StorageChangeOrigin.All,
            )
            .subscribe((change) => {
                if (change.value) {
                    this.newExperimentTrigger$.next(true);
                    this.infected = this.getInfectedFromStorage();
                    if (this.infected && this.infected.length) {
                        this.stateService.setState({ infected: this.infected });
                    } else {
                        this.stateService.removePropertyFromState('infected');
                    }
                }
            });
    }

    getInfected(): Infected[] {
        return this.infected;
    }

    private getInfectedFromStorage(): Infected[] {
        const experiments = this.pulseStorage.getJSON<Experiment[]>(
            this.config.experimentStorageKey,
        );

        if (!experiments) {
            return [];
        }

        return experiments
            ?.filter((experiment) => experiment.participation_date && experiment.trackable)
            .map((experiment) => ({
                id: experiment.name,
                variant: experiment.variant,
                participation_timestamp: experiment.participation_date,
                participation_session: experiment.participation_session,
            })) as Infected[];
    }
}
